var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDonationTax = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C9CFF",
  d: "M6.013 11.987H3.2a.8.8 0 0 0-.8.8V18.8a.8.8 0 0 0 .8.8h2.013a.8.8 0 0 0 .8-.8z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFBE9E",
  d: "M6.013 11.987h6.037v1.25L9.595 14.63H20.8a.8.8 0 0 1 .8.8v.602a.8.8 0 0 1-.534.755L13.26 19.53a.8.8 0 0 1-.265.045h-2.802a.8.8 0 0 1-.338-.075l-3.842-1.788z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6562",
  d: "M17.499 4.296a3.92 3.92 0 0 0-2.255-.696 3.64 3.64 0 0 0-1.938.585 4.7 4.7 0 0 0-.934.804 17 17 0 0 0-.469-.392 4.04 4.04 0 0 0-2.588-.9A3.53 3.53 0 0 0 6.79 4.77c-1.43 1.488-1.616 3.593-.52 5.925.717 1.53 2.178 2.921 3.276 3.82.762.62 1.71 1.332 2.398 1.63l-.006.01a1.2 1.2 0 0 0 .562.134.9.9 0 0 0 .296-.043q.102-.029.195-.073l-.001-.001c.363-.166.976-.56 2.11-1.515.934-.786 2.244-2.01 3.18-3.387.54-.792.908-1.78 1.066-2.86.22-1.515-.538-3.206-1.846-4.112Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFBE9E",
  d: "M11.675 13.474a.808.808 0 0 0-.43-1.487H6.012L9.6 14.8z"
})));
export default SvgDonationTax;